module.exports = function createSession(loadSession) {
  return {
    namespaced: true,
    state: { status: 'loading', user: null },
    mutations: {
      loading(state) { state.status = 'loading'; state.user = null; },
      ready(state, user) { state.user = user; state.status = 'ready'; },
      failed(state, expired) { state.user = null; state.status = expired ? 'expired' : 'error'; }
    },
    actions: {
      async load({ commit }) {
        commit('loading');
        try { commit('ready', await loadSession()); }
        catch (error) { commit('failed', error.response && error.response.status === 401); }
      }
    }
  };
};
